module.exports = __webpack_public_path__ + "img/dermapen.b967d7b4.png";